import { tierByID, tierCreate, tierDestroy, tierList, tierUpdate } from '@/services/agency/tiers.service'

export default {
	namespaced: true,
	state: {
		// SERVICE TIER
		tierList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		tier: {},

		// STATUS SERVICE TIER
		tierStatus: 'pending',
		tierSaveStatus: 'init',
		tierDeleteStatus: 'init',
	},
	getters: {
		// SERVICE TIER
		getTierList(state) {
			return state.tierList
		},
		getTier(state) {
			return state.tier
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE TIER
		getTierDeleteStatus(state) {
			return state.tierDeleteStatus
		},
		getTierSaveStatus(state) {
			return state.tierSaveStatus
		},
		getTierStatus(state) {
			return state.tierStatus
		},
	},
	mutations: {
		// SERVICE TIER
		TIER_LIST(state, value) {
			state.tierList = value
		},
		SET_TIER(state, value) {
			state.tier = value
		},

		// STATUS SERVICE TIER
		TIER_STATUS(state, value) {
			state.tierStatus = value
		},
		TIER_SAVE_STATUS(state, value) {
			state.tierSaveStatus = value
		},
		TIER_DELETE_STATUS(state, value) {
			state.tierDeleteStatus = value
		},
	},
	actions: {
		// Service Tier
		async fetchTierList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('TIER_STATUS', 'pending')
			commit('TIER_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await tierList(params)
				commit('TIER_STATUS', 'init')
				commit('TIER_LIST', data)
				return data
			} catch (error) {
				commit('TIER_STATUS', 'init')
				throw error
			}
		},
		async fetchTierByID({ commit }, params) {
			commit('TIER_STATUS', 'pending')
			try {
				const { data } = await tierByID(params)
				commit('TIER_STATUS', 'init')
				commit('SET_TIER', data.data)
				return data
			} catch (error) {
				commit('TIER_STATUS', 'init')

				return error
			}
		},
		async saveNewTier({ commit }, params) {
			commit('TIER_SAVE_STATUS', 'pending')
			try {
				const { data } = await tierCreate(params)
				commit('TIER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TIER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateTier({ commit }, params) {
			commit('TIER_SAVE_STATUS', 'pending')
			try {
				const { data } = await tierUpdate(params)
				commit('TIER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TIER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteTierByID({ commit }, params) {
			commit('TIER_DELETE_STATUS', 'pending')
			try {
				const { data } = await tierDestroy(params)
				commit('TIER_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TIER_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
